import React, { memo } from "react";

import { classNames } from "helpers";
import { ENTITY_TYPE_LABELS } from "services/api/notifications/consts";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import CheckIcon from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleEditCard/components/VehicleWizardIntro/scenes/CheckIcon";

import { NOTIFICATION_INTRO_TYPES } from "../consts";
import { NotificationSceneProps } from "../types";

/** Korak "Grupa": popis onoga što se može pratiti s istaknutim odabirom, pa odbrojavanje do isteka. */
const NotificationTypeScene: React.FC<NotificationSceneProps> = ({ notification }) => {
  // Odabrani tip mora biti na popisu, i kad nije među istaknutima.
  const types = NOTIFICATION_INTRO_TYPES.includes(notification.entityType)
    ? NOTIFICATION_INTRO_TYPES
    : [notification.entityType, ...NOTIFICATION_INTRO_TYPES.slice(0, 3)];

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Što pratimo</div>
          <div className="text-sm font-bold text-slate-800 truncate">{notification.entityLabel}</div>
          <div className="mt-3 space-y-2">
            {types.map((type) => {
              const isSelected = type === notification.entityType;
              return (
                <div
                  key={type}
                  className={classNames(
                    "flex items-center justify-between gap-2 rounded-md px-3 py-2 text-[0.7rem]",
                    isSelected ? "bg-blue-50 ring-1 ring-blue-200" : "bg-slate-50"
                  )}
                >
                  <span className={classNames("truncate", isSelected ? "font-semibold text-blue-700" : "text-slate-500")}>
                    {ENTITY_TYPE_LABELS[type]}
                  </span>
                  {isSelected && <CheckIcon />}
                </div>
              );
            })}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Do isteka</div>
          <div className="mt-2 text-xl font-bold text-slate-800">{notification.daysBeforeExpiry} dana</div>
          <div className="mt-1 text-[0.65rem] text-slate-400 truncate">
            {notification.entityName}, ističe {notification.expiryDate}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Podsjetnik na vrijeme"
          subtitle="Prije nego što nešto istekne"
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M18 8a6 6 0 00-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(NotificationTypeScene);
